"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.filter.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _gridStyled = require("grid-styled");
var _get = _interopRequireDefault(require("lodash/get"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _activityIndicator = _interopRequireDefault(require("@gravity/activity-indicator"));
var _button = require("@gravity/button");
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _link = _interopRequireDefault(require("@gravity/link"));
var _section = require("@gravity/section");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _filter = require("@nucleo/filter");
var _productList = require("@nucleo/product-list");
var _section2 = _interopRequireWildcard(require("@nucleo/section"));
var _constants = require("./constants");
var _helper = require("./helper");
var _skeleton = _interopRequireDefault(require("@gravity/skeleton"));
var _jsxFileName = "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/SectionProducts.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _this = void 0,
  _templateObject10,
  _templateObject11;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_15g71wzjsn() {
  var path = "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/SectionProducts.js";
  var hash = "39cccea0ca68c391b35d0b315040da8650982521";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/SectionProducts.js",
    statementMap: {
      "0": {
        start: {
          line: 33,
          column: 23
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "1": {
        start: {
          line: 35,
          column: 24
        },
        end: {
          line: 35,
          column: 90
        }
      },
      "2": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 45,
          column: 17
        }
      },
      "3": {
        start: {
          line: 48,
          column: 27
        },
        end: {
          line: 48,
          column: 68
        }
      },
      "4": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 54,
          column: 9
        }
      },
      "5": {
        start: {
          line: 61,
          column: 10
        },
        end: {
          line: 62,
          column: 19
        }
      },
      "6": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 69,
          column: 9
        }
      },
      "7": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 79,
          column: 9
        }
      },
      "8": {
        start: {
          line: 84,
          column: 16
        },
        end: {
          line: 102,
          column: 1
        }
      },
      "9": {
        start: {
          line: 104,
          column: 29
        },
        end: {
          line: 142,
          column: 1
        }
      },
      "10": {
        start: {
          line: 105,
          column: 2
        },
        end: {
          line: 141,
          column: 3
        }
      },
      "11": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 112,
          column: 7
        }
      },
      "12": {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 111,
          column: 10
        }
      },
      "13": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 113,
          column: 18
        }
      },
      "14": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 117,
          column: 8
        }
      },
      "15": {
        start: {
          line: 119,
          column: 6
        },
        end: {
          line: 121,
          column: 8
        }
      },
      "16": {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 125,
          column: 8
        }
      },
      "17": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 129,
          column: 8
        }
      },
      "18": {
        start: {
          line: 131,
          column: 6
        },
        end: {
          line: 133,
          column: 8
        }
      },
      "19": {
        start: {
          line: 135,
          column: 6
        },
        end: {
          line: 135,
          column: 18
        }
      },
      "20": {
        start: {
          line: 138,
          column: 6
        },
        end: {
          line: 140,
          column: 8
        }
      },
      "21": {
        start: {
          line: 144,
          column: 20
        },
        end: {
          line: 182,
          column: 1
        }
      },
      "22": {
        start: {
          line: 158,
          column: 24
        },
        end: {
          line: 158,
          column: 80
        }
      },
      "23": {
        start: {
          line: 163,
          column: 12
        },
        end: {
          line: 163,
          column: 83
        }
      },
      "24": {
        start: {
          line: 164,
          column: 28
        },
        end: {
          line: 164,
          column: 84
        }
      },
      "25": {
        start: {
          line: 184,
          column: 26
        },
        end: {
          line: 189,
          column: 2
        }
      },
      "26": {
        start: {
          line: 185,
          column: 2
        },
        end: {
          line: 188,
          column: 4
        }
      },
      "27": {
        start: {
          line: 191,
          column: 22
        },
        end: {
          line: 199,
          column: 1
        }
      },
      "28": {
        start: {
          line: 201,
          column: 20
        },
        end: {
          line: 207,
          column: 1
        }
      },
      "29": {
        start: {
          line: 209,
          column: 17
        },
        end: {
          line: 211,
          column: 1
        }
      },
      "30": {
        start: {
          line: 216,
          column: 4
        },
        end: {
          line: 221,
          column: 5
        }
      },
      "31": {
        start: {
          line: 217,
          column: 6
        },
        end: {
          line: 220,
          column: 8
        }
      },
      "32": {
        start: {
          line: 222,
          column: 4
        },
        end: {
          line: 226,
          column: 6
        }
      },
      "33": {
        start: {
          line: 230,
          column: 4
        },
        end: {
          line: 230,
          column: 17
        }
      },
      "34": {
        start: {
          line: 231,
          column: 4
        },
        end: {
          line: 235,
          column: 6
        }
      },
      "35": {
        start: {
          line: 238,
          column: 22
        },
        end: {
          line: 240,
          column: 3
        }
      },
      "36": {
        start: {
          line: 239,
          column: 4
        },
        end: {
          line: 239,
          column: 26
        }
      },
      "37": {
        start: {
          line: 243,
          column: 27
        },
        end: {
          line: 243,
          column: 75
        }
      },
      "38": {
        start: {
          line: 244,
          column: 26
        },
        end: {
          line: 244,
          column: 75
        }
      },
      "39": {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 248,
          column: 5
        }
      },
      "40": {
        start: {
          line: 247,
          column: 6
        },
        end: {
          line: 247,
          column: 28
        }
      },
      "41": {
        start: {
          line: 258,
          column: 15
        },
        end: {
          line: 278,
          column: 3
        }
      },
      "42": {
        start: {
          line: 259,
          column: 23
        },
        end: {
          line: 259,
          column: 33
        }
      },
      "43": {
        start: {
          line: 260,
          column: 68
        },
        end: {
          line: 260,
          column: 78
        }
      },
      "44": {
        start: {
          line: 262,
          column: 26
        },
        end: {
          line: 262,
          column: 54
        }
      },
      "45": {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 267,
          column: 8
        }
      },
      "46": {
        start: {
          line: 264,
          column: 41
        },
        end: {
          line: 267,
          column: 5
        }
      },
      "47": {
        start: {
          line: 268,
          column: 4
        },
        end: {
          line: 277,
          column: 6
        }
      },
      "48": {
        start: {
          line: 280,
          column: 22
        },
        end: {
          line: 301,
          column: 3
        }
      },
      "49": {
        start: {
          line: 281,
          column: 4
        },
        end: {
          line: 299,
          column: 5
        }
      },
      "50": {
        start: {
          line: 282,
          column: 6
        },
        end: {
          line: 282,
          column: 24
        }
      },
      "51": {
        start: {
          line: 284,
          column: 26
        },
        end: {
          line: 284,
          column: 63
        }
      },
      "52": {
        start: {
          line: 285,
          column: 6
        },
        end: {
          line: 287,
          column: 7
        }
      },
      "53": {
        start: {
          line: 286,
          column: 8
        },
        end: {
          line: 286,
          column: 20
        }
      },
      "54": {
        start: {
          line: 289,
          column: 45
        },
        end: {
          line: 289,
          column: 96
        }
      },
      "55": {
        start: {
          line: 293,
          column: 37
        },
        end: {
          line: 293,
          column: 94
        }
      },
      "56": {
        start: {
          line: 295,
          column: 6
        },
        end: {
          line: 298,
          column: 7
        }
      },
      "57": {
        start: {
          line: 296,
          column: 38
        },
        end: {
          line: 296,
          column: 95
        }
      },
      "58": {
        start: {
          line: 297,
          column: 8
        },
        end: {
          line: 297,
          column: 62
        }
      },
      "59": {
        start: {
          line: 300,
          column: 4
        },
        end: {
          line: 300,
          column: 16
        }
      },
      "60": {
        start: {
          line: 303,
          column: 21
        },
        end: {
          line: 308,
          column: 3
        }
      },
      "61": {
        start: {
          line: 304,
          column: 4
        },
        end: {
          line: 307,
          column: 8
        }
      },
      "62": {
        start: {
          line: 304,
          column: 41
        },
        end: {
          line: 307,
          column: 5
        }
      },
      "63": {
        start: {
          line: 325,
          column: 8
        },
        end: {
          line: 325,
          column: 18
        }
      },
      "64": {
        start: {
          line: 327,
          column: 29
        },
        end: {
          line: 327,
          column: 51
        }
      },
      "65": {
        start: {
          line: 328,
          column: 31
        },
        end: {
          line: 328,
          column: 55
        }
      },
      "66": {
        start: {
          line: 330,
          column: 6
        },
        end: {
          line: 330,
          column: 95
        }
      },
      "67": {
        start: {
          line: 331,
          column: 28
        },
        end: {
          line: 331,
          column: 66
        }
      },
      "68": {
        start: {
          line: 333,
          column: 24
        },
        end: {
          line: 333,
          column: 31
        }
      },
      "69": {
        start: {
          line: 335,
          column: 4
        },
        end: {
          line: 412,
          column: 6
        }
      },
      "70": {
        start: {
          line: 393,
          column: 31
        },
        end: {
          line: 393,
          column: 48
        }
      },
      "71": {
        start: {
          line: 394,
          column: 30
        },
        end: {
          line: 394,
          column: 55
        }
      },
      "72": {
        start: {
          line: 416,
          column: 0
        },
        end: {
          line: 447,
          column: 2
        }
      },
      "73": {
        start: {
          line: 449,
          column: 0
        },
        end: {
          line: 466,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 35,
            column: 15
          },
          end: {
            line: 35,
            column: 16
          }
        },
        loc: {
          start: {
            line: 35,
            column: 24
          },
          end: {
            line: 35,
            column: 90
          }
        },
        line: 35
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 43,
            column: 26
          },
          end: {
            line: 43,
            column: 27
          }
        },
        loc: {
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 45,
            column: 17
          }
        },
        line: 44
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 48,
            column: 18
          },
          end: {
            line: 48,
            column: 19
          }
        },
        loc: {
          start: {
            line: 48,
            column: 27
          },
          end: {
            line: 48,
            column: 68
          }
        },
        line: 48
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        },
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 54,
            column: 9
          }
        },
        line: 51
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 60,
            column: 28
          },
          end: {
            line: 60,
            column: 29
          }
        },
        loc: {
          start: {
            line: 61,
            column: 10
          },
          end: {
            line: 62,
            column: 19
          }
        },
        line: 61
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 65,
            column: 9
          }
        },
        loc: {
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        },
        line: 66
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        },
        loc: {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        },
        line: 72
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 104,
            column: 29
          },
          end: {
            line: 104,
            column: 30
          }
        },
        loc: {
          start: {
            line: 104,
            column: 51
          },
          end: {
            line: 142,
            column: 1
          }
        },
        line: 104
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 158,
            column: 15
          },
          end: {
            line: 158,
            column: 16
          }
        },
        loc: {
          start: {
            line: 158,
            column: 24
          },
          end: {
            line: 158,
            column: 80
          }
        },
        line: 158
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 162,
            column: 29
          },
          end: {
            line: 162,
            column: 30
          }
        },
        loc: {
          start: {
            line: 163,
            column: 12
          },
          end: {
            line: 163,
            column: 83
          }
        },
        line: 163
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 164,
            column: 19
          },
          end: {
            line: 164,
            column: 20
          }
        },
        loc: {
          start: {
            line: 164,
            column: 28
          },
          end: {
            line: 164,
            column: 84
          }
        },
        line: 164
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 184,
            column: 36
          },
          end: {
            line: 184,
            column: 37
          }
        },
        loc: {
          start: {
            line: 185,
            column: 2
          },
          end: {
            line: 188,
            column: 4
          }
        },
        line: 185
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 214,
            column: 2
          },
          end: {
            line: 214,
            column: 3
          }
        },
        loc: {
          start: {
            line: 214,
            column: 48
          },
          end: {
            line: 227,
            column: 3
          }
        },
        line: 214
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 229,
            column: 2
          },
          end: {
            line: 229,
            column: 3
          }
        },
        loc: {
          start: {
            line: 229,
            column: 21
          },
          end: {
            line: 236,
            column: 3
          }
        },
        line: 229
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 238,
            column: 22
          },
          end: {
            line: 238,
            column: 23
          }
        },
        loc: {
          start: {
            line: 238,
            column: 28
          },
          end: {
            line: 240,
            column: 3
          }
        },
        line: 238
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 242,
            column: 2
          },
          end: {
            line: 242,
            column: 3
          }
        },
        loc: {
          start: {
            line: 242,
            column: 43
          },
          end: {
            line: 249,
            column: 3
          }
        },
        line: 242
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 258,
            column: 15
          },
          end: {
            line: 258,
            column: 16
          }
        },
        loc: {
          start: {
            line: 258,
            column: 44
          },
          end: {
            line: 278,
            column: 3
          }
        },
        line: 258
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 264,
            column: 18
          },
          end: {
            line: 264,
            column: 19
          }
        },
        loc: {
          start: {
            line: 264,
            column: 41
          },
          end: {
            line: 267,
            column: 5
          }
        },
        line: 264
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 280,
            column: 22
          },
          end: {
            line: 280,
            column: 23
          }
        },
        loc: {
          start: {
            line: 280,
            column: 27
          },
          end: {
            line: 301,
            column: 3
          }
        },
        line: 280
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 303,
            column: 21
          },
          end: {
            line: 303,
            column: 22
          }
        },
        loc: {
          start: {
            line: 303,
            column: 27
          },
          end: {
            line: 308,
            column: 3
          }
        },
        line: 303
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 304,
            column: 18
          },
          end: {
            line: 304,
            column: 19
          }
        },
        loc: {
          start: {
            line: 304,
            column: 41
          },
          end: {
            line: 307,
            column: 5
          }
        },
        line: 304
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 310,
            column: 2
          },
          end: {
            line: 310,
            column: 3
          }
        },
        loc: {
          start: {
            line: 310,
            column: 11
          },
          end: {
            line: 413,
            column: 3
          }
        },
        line: 310
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 393,
            column: 25
          },
          end: {
            line: 393,
            column: 26
          }
        },
        loc: {
          start: {
            line: 393,
            column: 31
          },
          end: {
            line: 393,
            column: 48
          }
        },
        line: 393
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 394,
            column: 25
          },
          end: {
            line: 394,
            column: 26
          }
        },
        loc: {
          start: {
            line: 394,
            column: 30
          },
          end: {
            line: 394,
            column: 55
          }
        },
        line: 394
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 45,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 9
          },
          end: {
            line: 44,
            column: 20
          }
        }, {
          start: {
            line: 44,
            column: 24
          },
          end: {
            line: 44,
            column: 47
          }
        }, {
          start: {
            line: 44,
            column: 51
          },
          end: {
            line: 44,
            column: 89
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 45,
            column: 17
          }
        }],
        line: 44
      },
      "1": {
        loc: {
          start: {
            line: 48,
            column: 27
          },
          end: {
            line: 48,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 28
          },
          end: {
            line: 48,
            column: 43
          }
        }, {
          start: {
            line: 48,
            column: 47
          },
          end: {
            line: 48,
            column: 55
          }
        }, {
          start: {
            line: 48,
            column: 60
          },
          end: {
            line: 48,
            column: 68
          }
        }],
        line: 48
      },
      "2": {
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 54,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 20
          }
        }, {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 54,
            column: 9
          }
        }],
        line: 51
      },
      "3": {
        loc: {
          start: {
            line: 61,
            column: 10
          },
          end: {
            line: 62,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 11
          },
          end: {
            line: 61,
            column: 22
          }
        }, {
          start: {
            line: 61,
            column: 26
          },
          end: {
            line: 61,
            column: 49
          }
        }, {
          start: {
            line: 61,
            column: 53
          },
          end: {
            line: 61,
            column: 91
          }
        }, {
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 19
          }
        }],
        line: 61
      },
      "4": {
        loc: {
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 66,
            column: 20
          }
        }, {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        }],
        line: 66
      },
      "5": {
        loc: {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 41
          }
        }, {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        }],
        line: 72
      },
      "6": {
        loc: {
          start: {
            line: 105,
            column: 2
          },
          end: {
            line: 141,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 113,
            column: 18
          }
        }, {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 117,
            column: 8
          }
        }, {
          start: {
            line: 118,
            column: 4
          },
          end: {
            line: 121,
            column: 8
          }
        }, {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 125,
            column: 8
          }
        }, {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 129,
            column: 8
          }
        }, {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 133,
            column: 8
          }
        }, {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 135,
            column: 18
          }
        }, {
          start: {
            line: 136,
            column: 4
          },
          end: {
            line: 140,
            column: 8
          }
        }],
        line: 105
      },
      "7": {
        loc: {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 108
      },
      "8": {
        loc: {
          start: {
            line: 158,
            column: 24
          },
          end: {
            line: 158,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 158,
            column: 24
          },
          end: {
            line: 158,
            column: 42
          }
        }, {
          start: {
            line: 158,
            column: 46
          },
          end: {
            line: 158,
            column: 80
          }
        }],
        line: 158
      },
      "9": {
        loc: {
          start: {
            line: 163,
            column: 25
          },
          end: {
            line: 163,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 163,
            column: 25
          },
          end: {
            line: 163,
            column: 43
          }
        }, {
          start: {
            line: 163,
            column: 47
          },
          end: {
            line: 163,
            column: 81
          }
        }],
        line: 163
      },
      "10": {
        loc: {
          start: {
            line: 164,
            column: 28
          },
          end: {
            line: 164,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 164,
            column: 28
          },
          end: {
            line: 164,
            column: 46
          }
        }, {
          start: {
            line: 164,
            column: 50
          },
          end: {
            line: 164,
            column: 84
          }
        }],
        line: 164
      },
      "11": {
        loc: {
          start: {
            line: 187,
            column: 15
          },
          end: {
            line: 187,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 187,
            column: 15
          },
          end: {
            line: 187,
            column: 26
          }
        }, {
          start: {
            line: 187,
            column: 30
          },
          end: {
            line: 187,
            column: 48
          }
        }, {
          start: {
            line: 187,
            column: 52
          },
          end: {
            line: 187,
            column: 86
          }
        }],
        line: 187
      },
      "12": {
        loc: {
          start: {
            line: 216,
            column: 4
          },
          end: {
            line: 221,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 216,
            column: 4
          },
          end: {
            line: 221,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 216
      },
      "13": {
        loc: {
          start: {
            line: 246,
            column: 4
          },
          end: {
            line: 248,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 246,
            column: 4
          },
          end: {
            line: 248,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 246
      },
      "14": {
        loc: {
          start: {
            line: 246,
            column: 8
          },
          end: {
            line: 246,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 246,
            column: 8
          },
          end: {
            line: 246,
            column: 30
          }
        }, {
          start: {
            line: 246,
            column: 34
          },
          end: {
            line: 246,
            column: 73
          }
        }],
        line: 246
      },
      "15": {
        loc: {
          start: {
            line: 258,
            column: 16
          },
          end: {
            line: 258,
            column: 39
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 258,
            column: 34
          },
          end: {
            line: 258,
            column: 39
          }
        }],
        line: 258
      },
      "16": {
        loc: {
          start: {
            line: 262,
            column: 26
          },
          end: {
            line: 262,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 262,
            column: 44
          },
          end: {
            line: 262,
            column: 45
          }
        }, {
          start: {
            line: 262,
            column: 48
          },
          end: {
            line: 262,
            column: 54
          }
        }],
        line: 262
      },
      "17": {
        loc: {
          start: {
            line: 281,
            column: 4
          },
          end: {
            line: 299,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 281,
            column: 4
          },
          end: {
            line: 299,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 281
      },
      "18": {
        loc: {
          start: {
            line: 285,
            column: 6
          },
          end: {
            line: 287,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 285,
            column: 6
          },
          end: {
            line: 287,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 285
      },
      "19": {
        loc: {
          start: {
            line: 295,
            column: 6
          },
          end: {
            line: 298,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 295,
            column: 6
          },
          end: {
            line: 298,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 295
      },
      "20": {
        loc: {
          start: {
            line: 330,
            column: 6
          },
          end: {
            line: 330,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 330,
            column: 6
          },
          end: {
            line: 330,
            column: 45
          }
        }, {
          start: {
            line: 330,
            column: 49
          },
          end: {
            line: 330,
            column: 95
          }
        }],
        line: 330
      },
      "21": {
        loc: {
          start: {
            line: 331,
            column: 28
          },
          end: {
            line: 331,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 331,
            column: 28
          },
          end: {
            line: 331,
            column: 45
          }
        }, {
          start: {
            line: 331,
            column: 49
          },
          end: {
            line: 331,
            column: 66
          }
        }],
        line: 331
      },
      "22": {
        loc: {
          start: {
            line: 342,
            column: 9
          },
          end: {
            line: 362,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 342,
            column: 9
          },
          end: {
            line: 342,
            column: 43
          }
        }, {
          start: {
            line: 343,
            column: 10
          },
          end: {
            line: 361,
            column: 12
          }
        }],
        line: 342
      },
      "23": {
        loc: {
          start: {
            line: 359,
            column: 33
          },
          end: {
            line: 359,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 359,
            column: 52
          },
          end: {
            line: 359,
            column: 73
          }
        }, {
          start: {
            line: 359,
            column: 76
          },
          end: {
            line: 359,
            column: 99
          }
        }],
        line: 359
      },
      "24": {
        loc: {
          start: {
            line: 364,
            column: 9
          },
          end: {
            line: 382,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 364,
            column: 9
          },
          end: {
            line: 364,
            column: 42
          }
        }, {
          start: {
            line: 365,
            column: 10
          },
          end: {
            line: 381,
            column: 12
          }
        }],
        line: 364
      },
      "25": {
        loc: {
          start: {
            line: 384,
            column: 9
          },
          end: {
            line: 388,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 384,
            column: 9
          },
          end: {
            line: 384,
            column: 16
          }
        }, {
          start: {
            line: 385,
            column: 10
          },
          end: {
            line: 387,
            column: 17
          }
        }],
        line: 384
      },
      "26": {
        loc: {
          start: {
            line: 386,
            column: 13
          },
          end: {
            line: 386,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 386,
            column: 34
          },
          end: {
            line: 386,
            column: 55
          }
        }, {
          start: {
            line: 386,
            column: 58
          },
          end: {
            line: 386,
            column: 70
          }
        }],
        line: 386
      },
      "27": {
        loc: {
          start: {
            line: 389,
            column: 9
          },
          end: {
            line: 410,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 389,
            column: 9
          },
          end: {
            line: 389,
            column: 24
          }
        }, {
          start: {
            line: 390,
            column: 10
          },
          end: {
            line: 390,
            column: 31
          }
        }, {
          start: {
            line: 391,
            column: 12
          },
          end: {
            line: 409,
            column: 22
          }
        }],
        line: 389
      },
      "28": {
        loc: {
          start: {
            line: 397,
            column: 17
          },
          end: {
            line: 403,
            column: 17
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 398,
            column: 18
          },
          end: {
            line: 400,
            column: 32
          }
        }, {
          start: {
            line: 402,
            column: 18
          },
          end: {
            line: 402,
            column: 35
          }
        }],
        line: 397
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0, 0, 0, 0, 0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0, 0],
      "28": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "39cccea0ca68c391b35d0b315040da8650982521"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_15g71wzjsn = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_15g71wzjsn();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SectionWrapper = (cov_15g71wzjsn().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: function className(props) {
    cov_15g71wzjsn().f[0]++;
    cov_15g71wzjsn().s[1]++;
    return "stx-ProductList-".concat(props.tabCode, " stx-ProductList-sectionProducts");
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      flex-direction: column;\n      padding: 0 1rem 1rem;\n      margin: 1.5rem;\n      background-color: ", ";\n\n      .stx-Section-heading {\n        margin: ", ";\n      }\n      ", ";\n    "])), function (props) {
  cov_15g71wzjsn().f[1]++;
  cov_15g71wzjsn().s[2]++;
  return (cov_15g71wzjsn().b[0][0]++, props.theme) && (cov_15g71wzjsn().b[0][1]++, props.theme.productList) && (cov_15g71wzjsn().b[0][2]++, props.theme.productList.contentBgColor) || (cov_15g71wzjsn().b[0][3]++, '#ffffff');
}, function (props) {
  cov_15g71wzjsn().f[2]++;
  cov_15g71wzjsn().s[3]++;
  return (cov_15g71wzjsn().b[1][0]++, props.collapsed) && (cov_15g71wzjsn().b[1][1]++, '2rem 0') || (cov_15g71wzjsn().b[1][2]++, '2rem 0');
}, function (props) {
  cov_15g71wzjsn().f[3]++;
  cov_15g71wzjsn().s[4]++;
  return (cov_15g71wzjsn().b[2][0]++, props.isHide) && (cov_15g71wzjsn().b[2][1]++, "\n          display: none;\n        ");
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      flex-direction: column;\n      ", ";\n\n      ", ";\n\n      ", ";\n    "])), _utils.gMediaQueries.sm(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n        background-color: ", "\n      "])), function (props) {
  cov_15g71wzjsn().f[4]++;
  cov_15g71wzjsn().s[5]++;
  return (cov_15g71wzjsn().b[3][0]++, props.theme) && (cov_15g71wzjsn().b[3][1]++, props.theme.productList) && (cov_15g71wzjsn().b[3][2]++, props.theme.productList.contentBgColor) || (cov_15g71wzjsn().b[3][3]++, '#ffffff');
}), function (props) {
  cov_15g71wzjsn().f[5]++;
  cov_15g71wzjsn().s[6]++;
  return (cov_15g71wzjsn().b[4][0]++, props.isHide) && (cov_15g71wzjsn().b[4][1]++, "\n          display: none;\n        ");
}, function (_ref) {
  var usingHospitalityProductLineLayout = _ref.usingHospitalityProductLineLayout;
  cov_15g71wzjsn().f[6]++;
  cov_15g71wzjsn().s[7]++;
  return (cov_15g71wzjsn().b[5][0]++, usingHospitalityProductLineLayout) && (cov_15g71wzjsn().b[5][1]++, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n          > .stx-Section {\n            > .stx-SectionHeading {\n              display: none;\n            }\n          }\n        "]))));
}))));
var MoreBox = (cov_15g71wzjsn().s[8]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: "stx-ProductList-buttonsContainer"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      margin: 1rem auto;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      margin: 0;\n      padding: 0;\n      margin: ", "px 0;\n\n      ", ";\n    "])), _themeMapper.evolutionTheme.spacings.xl, _utils.gMediaQueries.sm(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n        margin-bottom: 0;\n      "])))))));
cov_15g71wzjsn().s[9]++;
var getCustomSectionName = function getCustomSectionName(tabEnum, section) {
  cov_15g71wzjsn().f[7]++;
  cov_15g71wzjsn().s[10]++;
  switch (tabEnum) {
    case _productList.ProductTabEnum.EVENTS:
      cov_15g71wzjsn().b[6][0]++;
      cov_15g71wzjsn().s[11]++;
      // For event using suptopic name
      if (section.code === _section2.SectionCodeEnum.ALL_EVENTS) {
        cov_15g71wzjsn().b[7][0]++;
        cov_15g71wzjsn().s[12]++;
        return {
          id: "gravity.ProductList.".concat(section.code)
        };
      } else {
        cov_15g71wzjsn().b[7][1]++;
      }
      cov_15g71wzjsn().s[13]++;
      return null;
    case _productList.ProductTabEnum.SEASON_TICKETS:
      cov_15g71wzjsn().b[6][1]++;
      cov_15g71wzjsn().s[14]++;
      return {
        id: "gravity.ProductList.family.".concat(section.code)
      };
    case _productList.ProductTabEnum.VISIT:
      cov_15g71wzjsn().b[6][2]++;
      cov_15g71wzjsn().s[15]++;
      return {
        id: "gravity.ProductList.family.".concat(section.code)
      };
    case _productList.ProductTabEnum.GOODS:
      cov_15g71wzjsn().b[6][3]++;
      cov_15g71wzjsn().s[16]++;
      return {
        id: "gravity.ProductList.family.".concat(section.code)
      };
    case _productList.ProductTabEnum.OFFERS:
      cov_15g71wzjsn().b[6][4]++;
      cov_15g71wzjsn().s[17]++;
      return {
        id: "gravity.ProductList.offer.".concat(section.code)
      };
    case _productList.ProductTabEnum.HOSPITALITY_BUNDLE:
      cov_15g71wzjsn().b[6][5]++;
      cov_15g71wzjsn().s[18]++;
      return {
        id: "gravity.ProductList.family.".concat(_productList.ProductTabEnum.HOSPITALITY_BUNDLE)
      };
    case _productList.ProductTabEnum.TOURS:
      cov_15g71wzjsn().b[6][6]++;
      cov_15g71wzjsn().s[19]++;
      return null;
    default:
      cov_15g71wzjsn().b[6][7]++;
      cov_15g71wzjsn().s[20]++;
      // OTHER_PRODUcTS
      return {
        id: "gravity.ProductList.family.".concat(section.code)
      };
  }
};
var LoadMoreBtn = (cov_15g71wzjsn().s[21]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_link.default).attrs({
  className: "stx-ProductList-loadMorebtn",
  tabIndex: '0'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n      font-weight: 500;\n      font-size: 0.875rem;\n      line-height: 0.875rem;\n      text-transform: uppercase;\n      margin-top: 20px;\n      border: none;\n      line-height: ", ";\n      color: ", ";\n      &:hover {\n        background: none;\n        span {\n          text-decoration: ", ";\n          color: ", ";\n        }\n      }\n    "])), _stylingConstants.default.font.sizeL, function (props) {
  cov_15g71wzjsn().f[8]++;
  cov_15g71wzjsn().s[22]++;
  return (cov_15g71wzjsn().b[8][0]++, props.theme.button) && (cov_15g71wzjsn().b[8][1]++, props.theme.button.backgroundColor);
}, function (props) {
  cov_15g71wzjsn().f[9]++;
  cov_15g71wzjsn().s[23]++;
  return "underline ".concat((cov_15g71wzjsn().b[9][0]++, props.theme.button) && (cov_15g71wzjsn().b[9][1]++, props.theme.button.backgroundColor));
}, function (props) {
  cov_15g71wzjsn().f[10]++;
  cov_15g71wzjsn().s[24]++;
  return (cov_15g71wzjsn().b[10][0]++, props.theme.button) && (cov_15g71wzjsn().b[10][1]++, props.theme.button.backgroundColor);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      margin-top: 20px;\n      border: none;\n      color: ", ";\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-direction: row-reverse;\n      gap: ", "px;\n    "])), _themeMapper.evolutionTheme.hospitality.buttons.color, _themeMapper.evolutionTheme.hospitality.buttons.fontSize, _themeMapper.evolutionTheme.hospitality.buttons.lineHeight, _themeMapper.evolutionTheme.hospitality.buttons.fontWeight, _themeMapper.evolutionTheme.spacings.md))));
var ChevronDoubleDown = (cov_15g71wzjsn().s[25]++, (0, _styledComponents.withTheme)(function (props) {
  cov_15g71wzjsn().f[11]++;
  cov_15g71wzjsn().s[26]++;
  return /*#__PURE__*/_react.default.createElement(_icon.default, {
    iconName: "chevron-double-down",
    iconColor: (cov_15g71wzjsn().b[11][0]++, props.theme) && (cov_15g71wzjsn().b[11][1]++, props.theme.button) && (cov_15g71wzjsn().b[11][2]++, props.theme.button.backgroundColor),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 185,
      columnNumber: 3
    }
  });
}));
var ArrowDownIcon = (cov_15g71wzjsn().s[27]++, (0, _styledComponents.default)(_icon.default).attrs({
  iconName: 'riArrowDownSLine',
  size: _themeMapper.evolutionTheme.hospitality.icon.size,
  iconColor: _themeMapper.evolutionTheme.hospitality.buttons.color
})(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  height: ", ";\n  width: ", ";\n  color: ", ";\n"])), _themeMapper.evolutionTheme.hospitality.icon.size, _themeMapper.evolutionTheme.hospitality.icon.size, _themeMapper.evolutionTheme.hospitality.buttons.color));
var IconWrapper = (cov_15g71wzjsn().s[28]++, _styledComponents.default.div.attrs({
  className: 'stx-ProductList-chervonDoubleDownIcon'
})(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  margin-right: 5px;\n  margin-bottom: 2px;\n  display: inline-block;\n"]))));
var KEY_CODE = (cov_15g71wzjsn().s[29]++, {
  ENTER: 13
});
var SectionProducts = /*#__PURE__*/function (_Component) {
  function SectionProducts(_props) {
    var _this2;
    (0, _classCallCheck2.default)(this, SectionProducts);
    cov_15g71wzjsn().f[13]++;
    cov_15g71wzjsn().s[33]++;
    _this2 = _callSuper(this, SectionProducts, [_props]);
    (0, _defineProperty2.default)(_this2, "componentDidMount", (cov_15g71wzjsn().s[35]++, function () {
      cov_15g71wzjsn().f[14]++;
      cov_15g71wzjsn().s[36]++;
      _this2.onLoadMore(true);
    }));
    /**
     * Called on load more action event fired
     *
     * @memberof SectionProducts
     *
     * @param {boolean} isFilterChanged, if the filter has been changed we need to notify the nucleo to reset the items in the section
     */
    (0, _defineProperty2.default)(_this2, "onLoadMore", (cov_15g71wzjsn().s[41]++, function () {
      var isFilterChanged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_15g71wzjsn().b[15][0]++, false);
      cov_15g71wzjsn().f[16]++;
      var _ref2 = (cov_15g71wzjsn().s[42]++, _this2.state),
        offset = _ref2.offset;
      var _ref3 = (cov_15g71wzjsn().s[43]++, _this2.props),
        tab = _ref3.tab,
        section = _ref3.section,
        maxItemPerSection = _ref3.maxItemPerSection,
        filter = _ref3.filter,
        reportData = _ref3.reportData;
      // Reset offset to 0 if load when filter changed
      var currentOffset = (cov_15g71wzjsn().s[44]++, isFilterChanged ? (cov_15g71wzjsn().b[16][0]++, 0) : (cov_15g71wzjsn().b[16][1]++, offset));
      cov_15g71wzjsn().s[45]++;
      _this2.setState(function (prevState, props) {
        cov_15g71wzjsn().f[17]++;
        cov_15g71wzjsn().s[46]++;
        return _objectSpread(_objectSpread({}, prevState), {}, {
          offset: currentOffset + props.maxItemPerSection
        });
      });
      cov_15g71wzjsn().s[47]++;
      _this2.props.onLoadMore(currentOffset, maxItemPerSection, tab.code, section.code, filter, isFilterChanged, tab.customSectionDisplay, reportData.isReportContext);
    }));
    (0, _defineProperty2.default)(_this2, "handleLoadMoreKey", (cov_15g71wzjsn().s[48]++, function (e) {
      cov_15g71wzjsn().f[18]++;
      cov_15g71wzjsn().s[49]++;
      if (e.keyCode === KEY_CODE.ENTER) {
        cov_15g71wzjsn().b[17][0]++;
        cov_15g71wzjsn().s[50]++;
        _this2.onLoadMore();
        var sectionCode = (cov_15g71wzjsn().s[51]++, (0, _get.default)(_this2.props, 'section.code', null));
        cov_15g71wzjsn().s[52]++;
        if (!sectionCode) {
          cov_15g71wzjsn().b[18][0]++;
          cov_15g71wzjsn().s[53]++;
          return null;
        } else {
          cov_15g71wzjsn().b[18][1]++;
        }
        var PRODUCT_CARD_FOCUSABLE_ELEMENT = (cov_15g71wzjsn().s[54]++, ".stx-Section-".concat(sectionCode, " .stx-ProductActions a"));

        // Accessibility: To increase UX we set focus to the last focusable product before load more, then user could continue
        // using Tab button to focus recently loaded elements
        var productCardActionElems = (cov_15g71wzjsn().s[55]++, document.querySelectorAll(PRODUCT_CARD_FOCUSABLE_ELEMENT));
        cov_15g71wzjsn().s[56]++;
        if (productCardActionElems.length > 0) {
          cov_15g71wzjsn().b[19][0]++;
          var productLineActionElem = (cov_15g71wzjsn().s[57]++, productCardActionElems[productCardActionElems.length - 1]);
          cov_15g71wzjsn().s[58]++;
          productLineActionElem.focus({
            preventScroll: false
          });
        } else {
          cov_15g71wzjsn().b[19][1]++;
        }
      } else {
        cov_15g71wzjsn().b[17][1]++;
      }
      cov_15g71wzjsn().s[59]++;
      return null;
    }));
    (0, _defineProperty2.default)(_this2, "handleOnCollapse", (cov_15g71wzjsn().s[60]++, function () {
      cov_15g71wzjsn().f[19]++;
      cov_15g71wzjsn().s[61]++;
      _this2.setState(function (prevState, props) {
        cov_15g71wzjsn().f[20]++;
        cov_15g71wzjsn().s[62]++;
        return _objectSpread(_objectSpread({}, prevState), {}, {
          collapsed: !prevState.collapsed
        });
      });
    }));
    cov_15g71wzjsn().s[34]++;
    _this2.state = {
      offset: 0,
      filter: _props.filter,
      collapsed: false
    };
    return _this2;
  }
  (0, _inherits2.default)(SectionProducts, _Component);
  return (0, _createClass2.default)(SectionProducts, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      cov_15g71wzjsn().f[15]++;
      var previousFilter = (cov_15g71wzjsn().s[37]++, prevProps.filter.filterByTab[prevProps.tab.code]);
      var currentFilter = (cov_15g71wzjsn().s[38]++, this.props.filter.filterByTab[prevProps.tab.code]);
      // Only update if the filter has changed
      cov_15g71wzjsn().s[39]++;
      if ((cov_15g71wzjsn().b[14][0]++, !(0, _isNil.default)(previousFilter)) && (cov_15g71wzjsn().b[14][1]++, !(0, _isEqual.default)(previousFilter, currentFilter))) {
        cov_15g71wzjsn().b[13][0]++;
        cov_15g71wzjsn().s[40]++;
        this.onLoadMore(true);
      } else {
        cov_15g71wzjsn().b[13][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      cov_15g71wzjsn().f[21]++;
      var _ref4 = (cov_15g71wzjsn().s[63]++, this.props),
        section = _ref4.section,
        aspectRatio = _ref4.aspectRatio,
        waitingListEnabled = _ref4.waitingListEnabled,
        currencyCode = _ref4.currencyCode,
        isSignedIn = _ref4.isSignedIn,
        tab = _ref4.tab,
        columns = _ref4.columns,
        displayActionBtn = _ref4.displayActionBtn,
        maxItemPerSection = _ref4.maxItemPerSection,
        reportData = _ref4.reportData,
        ecommerceGoogleTracking = _ref4.ecommerceGoogleTracking,
        resaleAvailability = _ref4.resaleAvailability,
        themeQueries = _ref4.themeQueries;
      var isEvolutionTheme = (cov_15g71wzjsn().s[64]++, themeQueries.EVOLUTION);
      var isEquilibriumTheme = (cov_15g71wzjsn().s[65]++, themeQueries.EQUILIBRIUM);
      var usingHospitalityProductLineLayout = (cov_15g71wzjsn().s[66]++, (cov_15g71wzjsn().b[20][0]++, tab.code === _productList.ProductTabEnum.HOSPITALITY) || (cov_15g71wzjsn().b[20][1]++, tab.code === _productList.ProductTabEnum.HOSPITALITY_BUNDLE));
      var hospItemPerPage = (cov_15g71wzjsn().s[67]++, (cov_15g71wzjsn().b[21][0]++, this.state.offset) || (cov_15g71wzjsn().b[21][1]++, maxItemPerSection));
      // handle to prevent unpected re-render section
      var _ref5 = (cov_15g71wzjsn().s[68]++, section),
        LOADING = _ref5.LOADING;
      cov_15g71wzjsn().s[69]++;
      return /*#__PURE__*/_react.default.createElement(SectionWrapper, {
        key: section.code,
        tabCode: tab.code,
        collapsed: this.state.collapsed,
        usingHospitalityProductLineLayout: usingHospitalityProductLineLayout,
        isHide: (0, _helper.isSectionEmpty)(section),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 336,
          columnNumber: 7
        }
      }, (cov_15g71wzjsn().b[22][0]++, !usingHospitalityProductLineLayout) && (cov_15g71wzjsn().b[22][1]++, /*#__PURE__*/_react.default.createElement(_section.Section, {
        key: section.code,
        layout: 'DEFAULT',
        section: section,
        columns: columns,
        displayActionBtn: displayActionBtn,
        customSectionName: getCustomSectionName(tab.code, section),
        currencyCode: currencyCode,
        waitingListEnabled: waitingListEnabled,
        isSignedIn: isSignedIn,
        aspectRatio: aspectRatio,
        onCollapse: this.handleOnCollapse,
        collapsed: this.state.collapsed,
        reportData: reportData,
        ecommerceGoogleTracking: ecommerceGoogleTracking,
        resaleAvailability: resaleAvailability,
        actionButtonVariant: isEvolutionTheme ? (cov_15g71wzjsn().b[23][0]++, _button.ButtonVariant.primary) : (cov_15g71wzjsn().b[23][1]++, _button.ButtonVariant.secondary),
        fullWidthActionButtonBreakpoint: _constants.FULL_WIDTH_ACTION_BUTTON_BREAKPOINT,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 343,
          columnNumber: 11
        }
      })), (cov_15g71wzjsn().b[24][0]++, usingHospitalityProductLineLayout) && (cov_15g71wzjsn().b[24][1]++, /*#__PURE__*/_react.default.createElement(_section.Section, {
        key: section.code,
        layout: 'PAGINATED_LIST',
        section: section,
        columns: columns,
        maxItemPerPage: hospItemPerPage,
        displayActionBtn: displayActionBtn,
        customSectionName: getCustomSectionName(tab.code, section),
        currencyCode: currencyCode,
        waitingListEnabled: waitingListEnabled,
        isSignedIn: isSignedIn,
        displayDescPreview: Boolean(true),
        displayPriceInfo: Boolean(true),
        hideShowMoreButton: Boolean(true),
        reportData: reportData,
        ecommerceGoogleTracking: ecommerceGoogleTracking,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 365,
          columnNumber: 11
        }
      })), (cov_15g71wzjsn().b[25][0]++, LOADING) && (cov_15g71wzjsn().b[25][1]++, /*#__PURE__*/_react.default.createElement(_gridStyled.Flex, {
        m: "auto",
        py: 2,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 385,
          columnNumber: 11
        }
      }, isEquilibriumTheme ? (cov_15g71wzjsn().b[26][0]++, /*#__PURE__*/_react.default.createElement(_activityIndicator.default, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 386,
          columnNumber: 35
        }
      })) : (cov_15g71wzjsn().b[26][1]++, /*#__PURE__*/_react.default.createElement(_skeleton.default, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 386,
          columnNumber: 59
        }
      })))), (cov_15g71wzjsn().b[27][0]++, section.hasMore) && (cov_15g71wzjsn().b[27][1]++, !this.state.collapsed) && (cov_15g71wzjsn().b[27][2]++, /*#__PURE__*/_react.default.createElement(MoreBox, {
        mt: 3,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 391,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(LoadMoreBtn, {
        onClick: function onClick() {
          cov_15g71wzjsn().f[22]++;
          cov_15g71wzjsn().s[70]++;
          return _this3.onLoadMore();
        },
        onKeyUp: function onKeyUp(e) {
          cov_15g71wzjsn().f[23]++;
          cov_15g71wzjsn().s[71]++;
          return _this3.handleLoadMoreKey(e);
        },
        disabled: LOADING,
        outline: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 392,
          columnNumber: 15
        }
      }, isEquilibriumTheme ? (cov_15g71wzjsn().b[28][0]++, /*#__PURE__*/_react.default.createElement(IconWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 398,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(ChevronDoubleDown, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 399,
          columnNumber: 21
        }
      }))) : (cov_15g71wzjsn().b[28][1]++, /*#__PURE__*/_react.default.createElement(ArrowDownIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 402,
          columnNumber: 19
        }
      })), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: 'gravity.ProductList.button.loadMore',
        defaultMessage: 'Load more',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 404,
          columnNumber: 17
        }
      })))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      cov_15g71wzjsn().f[12]++;
      cov_15g71wzjsn().s[30]++;
      // Resetting state when filter has been changed
      if (!(0, _isEqual.default)(props.filter.filterCriteria, state.filter.filterCriteria)) {
        cov_15g71wzjsn().b[12][0]++;
        cov_15g71wzjsn().s[31]++;
        return {
          offset: 0,
          filter: props.filter
        };
      } else {
        cov_15g71wzjsn().b[12][1]++;
      }
      cov_15g71wzjsn().s[32]++;
      return {
        offset: state.offset,
        limit: props.maxItemPerSection,
        hasMore: props.hasMore
      };
    }
  }]);
}(_react.Component);
cov_15g71wzjsn().s[72]++;
SectionProducts.propTypes = {
  /* The tab contains list of section */
  tab: _productList.ProductTabType.isRequired,
  /* The section that contains products to display */
  section: _section2.default.isRequired,
  /* The function call on load more action is fired */
  onLoadMore: _propTypes.default.func.isRequired,
  /* Maximum item to fetch when firing load more event */
  maxItemPerSection: _propTypes.default.number,
  /* The needed currency to display prices */
  currencyCode: _propTypes.default.string.isRequired,
  /* Define if waiting list for product not yet in sales is opened */
  waitingListEnabled: _propTypes.default.bool,
  /* Identify a user signed in or not */
  isSignedIn: _propTypes.default.bool,
  /* The Aspect ratio for the image */
  aspectRatio: _propTypes.default.oneOf(['VERTICAL', 'HORIZONTAL', 'WIDE', 'SQUARE', 'LANDSCAPE']),
  /* Number of products card on a row */
  columns: _propTypes.default.number,
  /** Option to display action button */
  displayActionBtn: _propTypes.default.bool,
  /** Filter applied  */
  filter: _propTypes.default.shape(_filter.FilterType).isRequired,
  /* Contain data for handle display and action for report management */
  reportData: _propTypes.default.shape(_productList.ReportManagementDataType),
  /** Option to use google enhance tracking to push data to data layer */
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  resaleAvailability: _propTypes.default.shape({}),
  /** theme context */
  themeQueries: _utils.WithThemeQueriesType,
  currentTheme: _propTypes.default.string
};
cov_15g71wzjsn().s[73]++;
SectionProducts.defaultProps = {
  columns: 5,
  maxItemPerSection: 10,
  isSignedIn: false,
  aspectRatio: 'WIDE',
  waitingListEnabled: false,
  displayActionBtn: false,
  filter: {},
  reportData: {},
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {}
  },
  resaleAvailability: {},
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme,
  themeQueries: {}
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(SectionProducts));